import { Typography, Box } from "@mui/material";

export default function Header() {
  return (
    <>
      <Box
        component="header"
        sx={{
          bgcolor: "#1976d2",
          color: "white",
          py: 2,
          textAlign: "center",
          boxShadow: 2,
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            px: 2,
            fontSize: { xs: "1.35rem", sm: "1.75rem", md: "2.125rem" },
            lineHeight: 1.2,
          }}
        >
          Petrol Pump Management System
        </Typography>
      </Box>
    </>
  );
}
